import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../core/modules/common/components/Button';
import noop from '../../../../core/modules/common/tools/noop';
import CheckboxTreeSelector from '../../../common/components/CheckboxTreeSelector';
import OnlySelectedFilterCheckbox from '../../../common/components/OnlySelectedFilterCheckbox';
import Icons from '../../../../core/modules/common/components/Icons';
import themeStyles from '../../../../materialUiTheme';

const PostalOperatorSelector = (props) => {
  const {
    title = '',
    selected = [],
    onSelect = noop,
    onSelectAll = noop,
    onDeSelectAll = noop,
    isShowOnlySelected = false,
    onShowOnlySelected = noop,
    handlerNodes = [],
    openSaveSelectionModal,
  } = props;

  return (
    <div className="operator-selector-container">
      {handlerNodes.length ?
        <CheckboxTreeSelector
          title={title}
          nodes={handlerNodes}
          selected={selected}
          expandDisabled
          onSelect={onSelect}
          onSelectAll={onSelectAll}
          onDeSelectAll={onDeSelectAll}
        /> : <div />
      }

      <div className="operator-selector-footer">
        <OnlySelectedFilterCheckbox
          isShowOnlySelected={isShowOnlySelected}
          onShowOnlySelected={onShowOnlySelected}
          isDisabled={selected.length === 0}
        />
        <Button
          {...themeStyles.operatorSelectors.button}
          text="app.save.selection.button.label"
          onClick={() => openSaveSelectionModal()}
          iconComponent={<Icons.DownloadIcon />}
        />
      </div>
    </div>
  );
};

PostalOperatorSelector.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func,
  onSelectAll: PropTypes.func,
  onDeSelectAll: PropTypes.func,
  handlerNodes: PropTypes.arrayOf(PropTypes.object),
  isShowOnlySelected: PropTypes.bool,
  onShowOnlySelected: PropTypes.func,
  openSaveSelectionModal: PropTypes.func,
};

export default PostalOperatorSelector;
